import { render, staticRenderFns } from "./AppLazyContainer.vue?vue&type=template&id=65f0c6c3&"
import script from "./AppLazyContainer.vue?vue&type=script&lang=js&"
export * from "./AppLazyContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports